"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, Mail, Phone } from "lucide-react";
import { DEFAULT_IMAGES, CONTACT } from "@/lib/constants";
import { getPrice } from "@/lib/strapi";
import { fetchProductsData } from "@/lib/api";
import { ProductCard } from "@/components/shared/product-card";

interface ClientProps {
  categories: any[];
}

export default function ProductsPageClient({ categories }: ClientProps) {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const initLoad = async () => {
      const fetchProduct = await fetchProductsData(selectedCategory);
      setProducts(fetchProduct);
    };
    initLoad();
  }, [selectedCategory]);

  return (
    <>
      {/* Filter + Products Section */}
      <section className="px-4 pt-10 pb-20 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          {/* Category Filter Pills */}
          <div className="flex flex-wrap gap-2 mb-8 pb-6 border-b border-slate-200">
            <button
              key={`prod-category-all`}
              onClick={() => setSelectedCategory("")}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                selectedCategory === ""
                  ? "bg-primary text-white shadow-sm"
                  : "bg-slate-100 text-slate-600 hover:bg-slate-200"
              }`}
            >
              TẤT CẢ
            </button>

            {categories.map((cat) => (
              <button
                key={`prod-category-${cat.slug}`}
                onClick={() => setSelectedCategory(cat.slug)}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                  selectedCategory === cat.slug
                    ? "bg-primary text-white shadow-sm"
                    : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                {cat.name.toUpperCase()}
              </button>
            ))}
          </div>

          {/* Products Grid */}
          <div className="grid gap-7 sm:grid-cols-2 lg:grid-cols-3">
            {products.map((product: any) => {
              return (
                <ProductCard key={`product-${product.slug}`} product={product} />
              );
            })}
          </div>

          {products.length === 0 && (
            <div className="text-center py-16">
              <p className="text-muted-foreground text-base">
                Không tìm thấy sản phẩm trong danh mục này
              </p>
            </div>
          )}
        </div>
      </section>

    </>
  );
}
